module.exports = __webpack_public_path__ + "static/knittedbowhamper-8f46180b13de46469d128ddc6b6f9571.jpeg";